import React, { useState } from 'react'
import { getImages } from '../Common/const'
import { motion } from "framer-motion";
import UseScrollReveal from '../Common/UseScrollReveal';
import SeoMeta from '../Common/SeoMeta';
import ModalLayout from '../Common/ModalLayout';
import BookAppointmentModal from '../Components/Service/BookAppointmentModal';

const Detailing = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const handleMouseMove = (e) => {
        const { clientX, clientY, currentTarget } = e;
        const { left, top, width, height } = currentTarget.getBoundingClientRect();
        const x = ((clientX - left) / width - 2) * 20;
        const y = ((clientY - top) / height - 1) * 20;
        const bgX = ((clientX - left) / width - 5) * 30;
        const bgY = ((clientY - top) / height - 0.5) * 30;
        setPosition({ x, y, bgX, bgY });
    };
    UseScrollReveal();

    const [openBookAppointment, setOpenBookAppointment] = useState(false);
    const handleBookAppointment = () => {
        setOpenBookAppointment(true);
        document.body.classList.add('body-overflow');
    }
    const closeBookAppointment = () => {
        setOpenBookAppointment(false)
        document.body.classList.remove('body-overflow');
    }
    return (
        <>
            <SeoMeta
                title="Detail"
                description=""
                keywords=""
                ogTitle="Detail"
                ogDescription=""
            />
            <section className="common-banner-wrap">
                <img src={getImages('Detailing-hero.webp')} alt='hero' />
                <div className="container">
                    <div className='common-banner-pos pt-140 text-center'>
                        <h1 className='banner-lg-title text-uppercase wow reveal fadeInUp'>Auto Detailing</h1>
                        <div className='my-4 wow reveal fadeInUp'>
                            <button type='button' className='orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase' onClick={handleBookAppointment}>Schedule Service</button>
                        </div>
                        <div className='text-center wow reveal fadeInUp'>
                            <a href='tel:8135880905' className='sm-title font-1-5em fw-400 avenir-next text-white'>
                                (813) 588-0905
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <section className='car-detailing-wrap'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-md-6 text-center wow reveal fadeInLeft'>
                            <img src={getImages('Car-Detailing-Services-image1.png')} alt='Detailing' />
                        </div>
                        <div className='col-md-6 mt-md-0 mt-5 wow reveal fadeInRight'>
                            <div className='add-border-left'>
                                <div className='md-title font-2-5em fw-400 text-uppercase mb-md-4 mb-3'>Car Detailing Services</div>
                                <div className='common-text'>
                                    <p>Just "good service" isn't good enough for your supercar. Truly exceptional vehicles deserve truly exceptional detailing services. At European Exotic Center, your exotic car will always receive high-quality care from our world-class service team, guaranteed.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='detail-package-wrap'>
                <div className='container'>
                    <div className='row align-items-center mb-90'>
                        <div className='col-md-6 text-center order-md-2 wow reveal fadeInRight'>
                            <img src={getImages('detail-package-image.png')} alt='Detailing' />
                        </div>
                        <div className='col-md-6 mt-md-0 mt-5 wow reveal fadeInLeft'>
                            <div className='add-border-left'>
                                <div className='md-title font-2-5em fw-400 text-uppercase mb-md-4 mb-3 pt-md-2'>Detail Packages</div>
                                {/*<div className='common-text'>
                                    <p>Just "good service" isn't good enough for your supercar. Truly exceptional vehicles deserve truly exceptional detailing services. At European Exotic Center, your exotic car will always receive high-quality care from our world-class service team, guaranteed.</p>
                                </div>*/}
                            </div>
                        </div>
                    </div>
                    <div className='wow reveal fadeInUp'>
                        <ul className='oe-list-flex dp-list-col4'>
                            <li>
                                <div className='d-flex align-items-center'>
                                    <div className='oe-icon'>
                                        <img src={getImages('arrow.svg')} />
                                    </div>
                                    <div className='sm-title eurostile text-uppercase pt-1'>Full interior vacuum of all upholstery and floor mats</div>
                                </div>
                            </li>
                            <li>
                                <div className='d-flex align-items-center'>
                                    <div className='oe-icon'>
                                        <img src={getImages('arrow.svg')} />
                                    </div>
                                    <div className='sm-title eurostile text-uppercase pt-1'>Deep cleaning of every crack and crevasse</div>
                                </div>
                            </li>
                            <li>
                                <div className='d-flex align-items-center'>
                                    <div className='oe-icon'>
                                        <img src={getImages('arrow.svg')} />
                                    </div>
                                    <div className='sm-title eurostile text-uppercase pt-1'>Paint correction</div>
                                </div>
                            </li>
                            <li>
                                <div className='d-flex align-items-center'>
                                    <div className='oe-icon'>
                                        <img src={getImages('arrow.svg')} />
                                    </div>
                                    <div className='sm-title eurostile text-uppercase pt-1'>Complete dash and interior surface wipe-down</div>
                                </div>
                            </li>
                            <li>
                                <div className='d-flex align-items-center'>
                                    <div className='oe-icon'>
                                        <img src={getImages('arrow.svg')} />
                                    </div>
                                    <div className='sm-title eurostile text-uppercase pt-1'>Surface conditioning and rehydration</div>
                                </div>
                            </li>
                            <li>
                                <div className='d-flex align-items-center'>
                                    <div className='oe-icon'>
                                        <img src={getImages('arrow.svg')} />
                                    </div>
                                    <div className='sm-title eurostile text-uppercase pt-1'>Touch-up paint</div>
                                </div>
                            </li>
                            <li>
                                <div className='d-flex align-items-center'>
                                    <div className='oe-icon'>
                                        <img src={getImages('arrow.svg')} />
                                    </div>
                                    <div className='sm-title eurostile text-uppercase pt-1'>Glass and mirror cleaning</div>
                                </div>
                            </li>
                            <li>
                                <div className='d-flex align-items-center'>
                                    <div className='oe-icon'>
                                        <img src={getImages('arrow.svg')} />
                                    </div>
                                    <div className='sm-title eurostile text-uppercase pt-1'>Ceramic hybrid wax treatment</div>
                                </div>
                            </li>
                            <li>
                                <div className='d-flex align-items-center'>
                                    <div className='oe-icon'>
                                        <img src={getImages('arrow.svg')} />
                                    </div>
                                    <div className='sm-title eurostile text-uppercase pt-1'>Wet sanding</div>
                                </div>
                            </li>
                            <li>
                                <div className='d-flex align-items-center'>
                                    <div className='oe-icon'>
                                        <img src={getImages('arrow.svg')} />
                                    </div>
                                    <div className='sm-title eurostile text-uppercase pt-1'>Surface conditioning and rehydration</div>
                                </div>
                            </li>
                            <li>
                                <div className='d-flex align-items-center'>
                                    <div className='oe-icon'>
                                        <img src={getImages('arrow.svg')} />
                                    </div>
                                    <div className='sm-title eurostile text-uppercase pt-1'>Engine bay detailing</div>
                                </div>
                            </li>
                            <li>
                                <div className='d-flex align-items-center'>
                                    <div className='oe-icon'>
                                        <img src={getImages('arrow.svg')} />
                                    </div>
                                    <div className='sm-title eurostile text-uppercase pt-1'>Ceramic coating</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <section className='book-appointment-wrap'>
                <div className="mouse-container"
                    onMouseMove={handleMouseMove}>
                    <motion.div
                        className="mouse-background"
                        style={{
                            background: `url(${getImages('detailing-schedule-bg.webp')}) no-repeat center/cover`
                        }}
                        animate={{
                            x: position.bgX,
                            y: position.bgY,
                        }}
                        transition={{ type: "tween", stiffness: 50 }}
                    />

                    <div className='w-100 text-center mouse-text'>
                        <div className='container'>
                            <div className='banner-lg-title font-3-5em text-uppercase wow reveal fadeInUp'>schedule an appointment</div>
                            <div className='sm-title font-1-2em mt-3 wow reveal fadeInUp'>We would love to work with you and have the opportunity to service your unique vehicle.</div>
                            <div className="my-4 wow reveal fadeInUp">
                                <button type="button" className="orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase" onClick={handleBookAppointment}>Schedule Service</button>
                            </div>
                            <div className='text-center wow reveal fadeInUp'>
                                <a href='tel:8135880905' className='sm-title font-1-5em fw-400 avenir-next text-white'>
                                    Or Call (813) 588-0905
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='brands-wrap'>
                <div className='container'>
                    <div className='md-title font-1-9em text-center mb-5 wow reveal fadeInUp d-none d-md-block'>WE ARE EXPERIENCED WORKING ON THESE BRANDS AND MORE</div>
                    <div className='md-title font-1-9em text-center mb-5 text-uppercase wow reveal fadeInUp d-block d-md-none'>Brands We Service</div>
                    <div className='d-flex brand-logos align-items-center justify-content-between px-md-5 wow reveal fadeInUp'>
                        <div>
                            <img src={getImages('logos/lambo.png')} alt='lambo' />
                        </div>
                        <div>
                            <img src={getImages('logos/benz.png')} alt='benz' />
                        </div>
                        <div>
                            <img src={getImages('logos/maserati-logo.png')} alt='maserati' />
                        </div>
                        <div>
                            <img src={getImages('logos/ferrari.png')} alt='ferrari' />
                        </div>
                        <div>
                            <img src={getImages('logos/porsche.png')} alt='porsche' />
                        </div>
                        <div>
                            <img src={getImages('logos/aston-martin.png')} alt='aston martin' />
                        </div>
                    </div>
                </div>
            </section>
            {openBookAppointment &&
                <ModalLayout open={openBookAppointment} close={closeBookAppointment} darkThemeCls='true' modalWidth={1030}>
                    <BookAppointmentModal close={closeBookAppointment} />
                </ModalLayout>
            }
        </>
    )
}

export default Detailing